import type { MetadataEntry } from '@/types/Models/Shipment'

const _parseMetadataCache = new Map<string, MetadataEntry[]>()

export const parseMetadata = (metadata: string | null | unknown): MetadataEntry[] => {
  if (!metadata) return []
  if (typeof metadata !== 'string') return [{ key: null, value: JSON.stringify(metadata).slice(0, 300) }]
  const cached = _parseMetadataCache.get(metadata)
  if (cached) return cached
  let result: MetadataEntry[]
  try {
    const parsed = JSON.parse(metadata)
    if (parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed)) {
      result = Object.entries(parsed).map(([k, v]): MetadataEntry => {
        if (v === null || typeof v !== 'object') return { key: k, value: String(v) }
        return { key: k, value: JSON.stringify(v) }
      })
    } else {
      result = [{ key: null, value: metadata.slice(0, 300) }]
    }
  } catch {
    result = [{ key: null, value: metadata.slice(0, 300) }]
  }
  _parseMetadataCache.set(metadata, result)
  return result
}

export const isFallback = (metadata: string | null | unknown): boolean => {
  if (!metadata) return false
  try {
    const parsed = typeof metadata === 'string' ? JSON.parse(metadata) : metadata
    return parsed?.selectionType === 'fallback'
  } catch {
    return false
  }
}

export const fallbackExtraMetadata = (metadata: string | null | unknown): MetadataEntry[] => {
  if (!metadata) return []
  try {
    const parsed = typeof metadata === 'string' ? JSON.parse(metadata) : metadata
    if (parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return Object.entries(parsed)
        .filter(([k]) => k !== 'selectionType')
        .map(([k, v]): MetadataEntry => ({
          key: k,
          value: v === null || typeof v !== 'object' ? String(v) : JSON.stringify(v),
        }))
    }
  } catch {
    // ignore
  }
  return []
}

export const isAddressUnavailable = (metadata: string | null | unknown): boolean => {
  if (!metadata) return false
  try {
    const parsed = typeof metadata === 'string' ? JSON.parse(metadata) : metadata
    return parsed?.error === 'address_unavailable'
  } catch {
    return false
  }
}

